/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Utility type to make complex types more readable in TypeScript.
 * This helps expand nested types for better IDE display and debugging.
 *
 * @example
 * type ComplexType = { a: { b: { c: string } } }
 * type PrettyType = Prettify<ComplexType> // More readable in IDE
 */
export type Prettify<T> = {
  [K in keyof T]: T[K]
} & {}

/*
 * This function is used to clean an object of empty values.
 */
export const cleanEmpty = function (
  obj: any,
  defaults = [undefined, null, NaN, ''],
): any {
  if (defaults.includes(obj)) return

  if (Array.isArray(obj))
    return obj
      .map((v) => (v && typeof v === 'object' ? cleanEmpty(v, defaults) : v))
      .filter((v) => !defaults.includes(v))

  return Object.entries(obj).length
    ? Object.entries(obj)
        .map(([k, v]) => [
          k,
          v && typeof v === 'object' ? cleanEmpty(v, defaults) : v,
        ])
        .reduce(
          (a, [k, v]) => (defaults.includes(v) ? a : { ...a, [k]: v }),
          {},
        )
    : obj
}
